<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch25"></a><a id="page_26"></a><a href="#/contents#ch25"><b>What’s in a Name?</b></a></h2>
<p class="noindent"><span>Most popular names for U.S. high school sports teams: Eagles and Tigers.</span></p>
<p class="noindent"><span>The troll dolls of the 1960s were also known as Dam Dolls, after their creator, Thomas Dam.</span></p>
<p class="noindent"><span>The first Atlantic storm to carry a man’s name was Hurricane Bob (1979). (Before that, they were all named after women.)</span></p>
<p class="noindent"><span>The O’ prefix in Irish surnames means “grandson of.”</span></p>
<p class="noindent"><span>Babe Ruth’s residence in Sudbury, Massachusetts, was named Home Plate Farm.</span></p>
<p class="noindent"><span>There are approximately 600 different surnames in China but more than a million in the United States.</span></p>
<p class="noindent"><span>Author Douglas Adams (<i>The Hitchhiker’s Guide to the Galaxy</i>) chose the name of Pink Floyd’s 1994 album <i>The Division Bell</i>.</span></p>
<p class="noindent"><span>To enter the Bob Jones Open golf tournament, you must be named Bob Jones.</span></p>
<p class="noindent"><span>The world’s most common name: Muhammad.</span></p>
<p class="noindent"><span>According to some studies, the surname Baer has the most spelling variations—36. Snyder is second with 29, and Bailey has 22. (But these are the most common spellings.)</span></p>
<p class="noindent"><span>Malcolm X named his first daughter, Attalah, after Attila the Hun.</span></p>
<p class="noindent"><span>Miss Ima Hogg, the “First Lady of Texas,” was a beloved philanthropist and patron of the arts.</span></p>
<p class="noindent"><span>Pete Townshend and John Entwistle of the Who played in a Dixieland band called the Confederates.</span></p>
<p class="noindent"><span>According to legend, Paul Bunyan’s cook was named Hot Biscuit Slim.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter25.vue?c97eec06